import { ChangeEvent, FocusEvent } from 'react';
import { Validation } from '../../validators/validator';
import { IUseValidatorConfig, IValidator, useValidator } from './useValidator';

export interface IInputValidator<T> extends Pick<IValidator<T>, `invalid` | `value` | `errorMessage`> {
  onBlur: (e: FocusEvent<HTMLInputElement, Element>) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const useInputValidator = <T>(initialValue: T, validation: Validation<T>, config: IUseValidatorConfig = {}): IInputValidator<T> => {
  const validator = useValidator(initialValue, validation, config);
  const { handleEvent, invalid, value, errorMessage } = validator;

  return {
    onBlur: (e: FocusEvent<HTMLInputElement>) => handleEvent(e.target.value as any),
    onChange: (e: ChangeEvent<HTMLInputElement>) => handleEvent(e.target.value as any),
    invalid,
    value,
    errorMessage
  };
};
